import React from 'react';
import { UiFlex } from '@open-stack/ui';
import { XTextTitle } from '../../text/XTextTitle';
import styled from 'styled-components';
import { XButton } from '../../button/XButton';

const Wrapper = styled(UiFlex)`
    background-color: var(--x-color-surface);
    border-top-left-radius: calc(4 * var(--x-border-radius));
    border-top-right-radius: calc(4 * var(--x-border-radius));
    position: sticky;
    top: 0;
    z-index: 2;
`;

interface Props {
    title: any;

    onClose?(): void;

    buttons?: any;
}

export function XDrawerBottomHeader({ title, onClose, buttons }: Props) {
    return (
        <Wrapper justifyContent="space-between" padding={2} paddingHorizontal={2} paddingLeft={2}>
            <XTextTitle>{title}</XTextTitle>

            <UiFlex>
                {buttons}
                {onClose && <XButton onClick={onClose} icon="close" />}
            </UiFlex>
        </Wrapper>
    );
}
